 let currentStep = 1;
    const totalSteps = 2;
    const progress = document.getElementById('progress');
    const stepTitle = document.getElementById('step-title');

    function updateUI() {
      document.querySelectorAll('.myform-step').forEach((step, index) => {
        step.classList.toggle('active', index + 1 === currentStep);
      });
      stepTitle.textContent = `Paso ${currentStep} de ${totalSteps}`;
      progress.style.width = `${(currentStep / totalSteps) * 100}%`;
    }

    function nextStep() {
      if (currentStep < totalSteps) {
        currentStep++;
        updateUI();
      }
    }

    function prevStep() {
      if (currentStep > 1) {
        currentStep--;
        updateUI();
      }
    }
function enviarFormulario(e) {
  e.preventDefault();

  const form = e.target;
  const formData = new FormData(form);
  const mensajeDiv = document.getElementById('mensaje');

  // Resetear mensaje
  mensajeDiv.classList.remove('show');
  mensajeDiv.style.display = 'none';
  mensajeDiv.textContent = '';

  fetch('https://merca3w.com/zebra/formulario-handler.php', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    // Estilos dinámicos según el resultado
    mensajeDiv.style.backgroundColor = data.success ? '#d4edda' : '#f8d7da';
    mensajeDiv.style.color = data.success ? '#155724' : '#721c24';
    mensajeDiv.style.border = `1px solid ${data.success ? '#c3e6cb' : '#f5c6cb'}`;
    mensajeDiv.textContent = data.message;

    // Mostrar con fade-in
    mensajeDiv.style.display = 'block';
    setTimeout(() => {
      mensajeDiv.classList.add('show');
    }, 10);

    if (data.success) {
      form.reset();
      currentStep = 1;
      updateUI();
    }

    // Ocultar después de 6 segundos (opcional)
    setTimeout(() => {
      mensajeDiv.classList.remove('show');
      setTimeout(() => mensajeDiv.style.display = 'none', 500);
    }, 6000);
  })
  .catch(error => {
    mensajeDiv.style.backgroundColor = '#f8d7da';
    mensajeDiv.style.color = '#721c24';
    mensajeDiv.style.border = '1px solid #f5c6cb';
    mensajeDiv.textContent = 'Error de conexión. Intenta más tarde.';
    mensajeDiv.style.display = 'block';
    setTimeout(() => mensajeDiv.classList.add('show'), 10);

    console.error(error);
  });
}